// If any import references a json file it scerws up auto import
// Don't put anything else in here
import App from './pending-users.config.json';
export const PendingUsersAppConfig = App.App;
